export default __webpack_public_path__ + "static/media/karoq.dc521841.png";